import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';
import { ToolInfo } from 'components';
import { postedNoteActions } from 'store';
import { FindLoad, Images, useModal } from 'utils';
import { AddPostedNote } from './addPostedNote';
import { PostedNoteDetail } from './postedNoteDetail';
import { POSTED_NOTE_TOOLTIP } from './constants';

const GET_POSTED_NOTE = 'GET_POSTED_NOTE';

export const PostedNoteAction = ({ clientId }) => {
    const dispatch = useDispatch();
    const { open } = useModal();
    const postedNote = useSelector((state) => state.postedNote.postedNote);
    const loader = FindLoad(GET_POSTED_NOTE);

    useEffect(() => {
        if (clientId) dispatch(postedNoteActions.getPostedNote(clientId));
    }, [clientId, dispatch]);

    const openAdd = () => open(<AddPostedNote clientId={clientId} />);
    const openDetail = () => open(<PostedNoteDetail clientId={clientId} />);

    if (loader?.length) {
        return (
            <div className="posted-note-trigger">
                <Skeleton variant="rounded" width={130} height={28} style={{ borderRadius: 16 }} />
            </div>
        );
    }

    if (!postedNote?.content) {
        return (
            <div className="posted-note-trigger">
                <button type="button" className="posted-note-add-btn" onClick={openAdd}>
                    <img
                        src={Images.postedNote}
                        alt="pushPin"
                        style={{
                            filter: 'brightness(0) saturate(100%) invert(36%) sepia(82%) saturate(6028%) hue-rotate(210deg) brightness(95%) contrast(91%)',
                        }}
                    />
                    <span>Add Posted Note</span>
                </button>
                <ToolInfo text={POSTED_NOTE_TOOLTIP} />
            </div>
        );
    }

    return (
        <div className="posted-note-trigger">
            <button type="button" className="posted-note-badge" onClick={openDetail}>
                <img
                    src={Images.postedNote}
                    alt="pushPin"
                    style={{
                        filter: 'brightness(0) saturate(100%) invert(48%) sepia(98%) saturate(348%) hue-rotate(0deg) brightness(96%) contrast(92%)',
                    }}
                />
                <span>Posted Note</span>
            </button>
        </div>
    );
};
